import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { ViewModeNotifier } from './view-mode-notifier';
import { ViewModeState } from './view-mode-state';

@Injectable()
export class ViewModeProvider extends BaseProvider<ViewModeNotifier, ViewModeState> {
  constructor() {
    super(ViewModeNotifier);
  }
}
